<template>
  <div>
    <!-- 卡片列表 -->
    <div v-loading="loading"
         class="card-prod-list">
      <!-- 遍历 -->
      <div class="card-prod"
           v-for="(o, index) in itemList"
           :key="index">
        <el-card shadow="none"
                 :body-style="{ padding: '0px' }">
          <!-- 推荐 标题 -->
          <div style="padding: 0px">
            <!-- 推荐标题:有2行，超过之后用... 显示 -->
            <div>
              <h3 class="card-recommend-title">
                {{ o.name }}
              </h3>
              <!-- 推荐介绍 -->
              <div class="card-recommend-introduce">
                <span style="width: 200px; overflow:hidden;word-break: keep-all; cursor: pointer">
                  {{ o.introduce > 18 ? o.introduce.slice(0, 18) + '...' :o.introduce}}
                </span>
              </div>
            </div>
            <!-- --------------------周边：迹点列表------------------------ -->
            <div v-for="(item, index) in o.traver_point"
                 :key="index"
                 size="mini"
                 type="">
              <divider-line></divider-line>
              <div style="padding: 5px 10px">
                <!-- 迹点标签 -->
                <i v-if="item.traver_class=='1'"
                   class="el-icon-fork-spoon"
                   size="mini"></i>
                <el-tag v-else-if="item.traver_class=='2'">餐厅</el-tag>
                {{item.traver_title}}
                <!-- 迹点介绍 -->
                <p style="margin-top:5px; color:gray"
                   v-html="item.traver_info.length > 18 ? item.traver_info.slice(0, 58) + '...' :item.traver_info"> </p>
              </div>
            </div>

            <divider-line></divider-line>
            <!-- 编辑按钮 -->
            <div style="padding:0px 10px 0px 10px ">
              <el-button size="mini"
                         @click="reNewRecommendList(o)"
                         style="width:100%;"
                         type="primary">修改</el-button>

            </div>
            <div style="padding:5px 10px 5px 10px ">
              <el-button size="mini"
                         @click="deleteRecommendList(o.id)"
                         style="width:100%;"
                         type="warning">删除</el-button>
            </div>
          </div>
        </el-card>
        <!-- 迹点列表 结束 -->
      </div>
      <!-- 通过判断itemList补充块 -->
      <div class="card-prod-none"
           v-if="itemList.length/4==1"></div>
      <div class="card-prod"
           v-else-if="(itemList.length-2)/4==0||1"
           v-for="(i,index) in ['a','b']"
           :key="index+4"></div>
      <div class="card-prod"
           v-else-if="(item,index) in ['a','b','c']"
           :key="index+4"
           v-show="(itemList.length-1)/4==0||1"></div>
    </div>

  </div>
</template>

<script >
import DividerLine from '../other/DividerLine'
export default {
  name: 'show-recommend-list',
  components: {
    'divider-line': DividerLine,
  },
  data() {
    return {
      loading: false,
      itemList: this.cardList,
    }
  },
  props: {
    cardList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  methods: {
    reNewRecommendList(val) {
      this.$emit('reNewRecommendList', val)
    },
    deleteRecommendList(val) {
      this.$emit('deleteRecommendList', val)
    },
  },
}
</script>

<style scoped>
/* 卡片 */
.card-prod-list {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-around; */
  justify-content: space-between;
  align-items: flex-start;
  /* background-color: red; */
}

.card-prod {
  margin: 5px;
  width: 35%;
  /* margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  margin-left: 10px; */
  /* cursor 光标属性，可以添加click事件 */
}
.card-prod-none {
  display: none;
}

/* 基本 */
.image {
  display: block;
  cursor: pointer;
}
/* 封面元素 */
.content_list_corner_dest {
  font-size: 15px;
  color: #fff;
  padding: 10px;
  background-color: #ff5421;
  /* width: 30%; */
  top: 0%;
  left: 0%;
}
.button {
  padding: 0;
  float: right;
}

.card-recommend-title {
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
  /* cursor: pointer; */
  padding: 10px 0px 5px 10px;
}
.card-recommend-introduce {
  padding: 0 10px;
  color: grey;
  height: auto;
}
</style>